import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/primeng';

import { DashboardSorttimeService } from '../../service/dashboard-sorttime/dashboard-sorttime.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard-sorttime-companies',
  templateUrl: './dashboard-sorttime-companies.component.html',
  styleUrls: ['./dashboard-sorttime-companies.component.scss']
})
export class DashboardSorttimeCompaniesComponent implements OnInit {
  public dashboard_url: SafeResourceUrl = null;
  public dashboard_name: string = null;
  public msgs: Message[] = [];
  public loading: boolean = true;

  public roleId: number = null;

  public company_report_form: FormGroup;
  public typeReportOptions: any[] = [];
  public companySorttime: any;
  public companyOptions: any[] = [];

  constructor(
    public dashboardSorttimeService: DashboardSorttimeService,
    private sanitizer: DomSanitizer,
    public fb: FormBuilder,
  ) {
    this.roleId = JSON.parse(localStorage.getItem('profile')).roles[0].id;

    this.typeReportOptions = [
      {label: 'Informe de rotación', value: 901},
      {label: 'Informe de acumulados', value: 902},
      {label: 'Informe de incapacidades', value: 903},
    ];
  }

  ngOnInit() {
    this.getCompaniesSorttime(this.typeReportOptions[0].value);   // Por defecto que sea Informe de rotación

    this.createCompanyReportsForm();
  }

  createCompanyReportsForm(data:any = null){
    data = data || {
      type_report: this.typeReportOptions[0].value,   // Por defecto que sea Informe de rotación
      company: ''
    }
   
    this.company_report_form = this.fb.group({
      type_report: [ data.type_report ],
      company: [ data.company ],
    });
  }

  public getCompaniesSorttime(reportType) {
    this.dashboardSorttimeService.getCompaniesToSorttime().toPromise().then(
      response => {
        var dashboard_request = response.json();

        for (var i = 0; i < dashboard_request.length; i++)
          this.companyOptions.push( { name: dashboard_request[i].name, id_sorttime: dashboard_request[i].id_sorttime } );
        
        this.defaultCompanyReport(reportType);
        this.loading = false;
      },
      error => {
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
        this.loading = false;
      }
    );
  }

  changeCompanyReport(event) {
    const reportType = event.value;
    this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSorttimeReport(reportType, this.companySorttime.id_sorttime));
  }

  changeCompany(event) {
    // this.companySorttime = event.target.value;
    this.companySorttime = this.company_report_form.get('company').value;

    this.company_report_form.get('type_report').setValue(this.typeReportOptions[0].value);

    this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSorttimeReport(this.typeReportOptions[0].value, this.companySorttime.id_sorttime));
    this.dashboard_name = this.companySorttime.name;
  }

  public defaultCompanyReport(reportType) {
    this.companySorttime = this.companyOptions[0];

    this.company_report_form.get('company').setValue(this.companySorttime);

    this.dashboard_name = this.companySorttime.name;
    this.dashboard_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSorttimeReport(reportType, this.companySorttime.id_sorttime));
  }

  public getSorttimeReport(reportType, idSorttimeCompany) {
    var url = 'https://sorttime.co/SorttimeBIClientes/Home/EmbedReport?empresa=RHS&';
    var token = 'RVrjvlGkf5aPozVAg145';

    url += 'idBI=' + reportType + '&idCliente=' + idSorttimeCompany + '&token=' + token;

    return url;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/dashboard-sorttime-companies/dashboard-sorttime-companies.component.ts